import React from 'react'
import styled from 'styled-components';

import SpeedyTag from './SpeedyTag';

const colors = {
  next: {
    background: '#CF0207',
    border: '#CF0207',
    text: 'white'
  },
  prev: {
    background: 'none',
    border: '#979797',
    text: '#979797'
  }
};

const Tag = styled(SpeedyTag)`
  background: ${({ type }) => colors[type].background};
  border: 2px solid ${({ type }) => colors[type].border};

  span {
    font-weight: bold;
    color: ${({ type }) => colors[type].text};
  }
`;

const Button = styled.a`
  &:hover {
    cursor: pointer;
  }
`;

const SpeedyButton = ({ type, className, children, onClick }) => (
  <Button onClick={onClick} className={className}>
    <Tag type={type} className={className}>
      <span>{children}</span>
    </Tag>
  </Button>
);

export default SpeedyButton;
